<div
	class="info-message"
	[ngClass]="validationBankRespose.status"
	*ngIf="validationBankRespose && validationBankRespose.status != 'validated'"
>
	<span class="freud-icon freud-icon-info-circle freud-icon-xs"></span>
	<p>{{ validationBankRespose.text | translate }}</p>
	<a *ngIf="validationBankRespose.status === 'has_errors' && !paymentScreen"
		class="link" 
		href="https://hs-info.zenklub.com/faq/como-informar-meus-dados-banc%C3%A1rios-para-o-repasse">
		Saiba mais aqui
	</a>
</div>
